<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <v-icon v-if="isActive" v-bind="attrs" v-on="on" color="green" small>
        mdi-check-bold
      </v-icon>
      <v-icon v-else v-bind="attrs" v-on="on" color="grey lighten-1" small>
        mdi-close-thick
      </v-icon>
    </template>
    {{ subtitle }}
  </v-tooltip>
</template>

<script>
export default {
  name: 'IconIsActive',
  props: {
    isActive: {
      type: Boolean,
    },
    subtitle: {
      required:true
    }
  },
}
</script>
